import {
    Users, GraduationCap, Building2,
   IndianRupee 
} from 'lucide-react';

export const attendanceData = [
    { day: 'Mon', present: 280, absent: 70 },
    { day: 'Tue', present: 230, absent: 40 },
    { day: 'Wed', present: 250, absent: 50 },
    { day: 'Thu', present: 200, absent: 45 },
    { day: 'Fri', present: 240, absent: 55 },
    { day: 'Sat', present: 270, absent: 30 },
];

export const genderData = [
    { name: 'Boys', value: 1700, color: '#4318FF' },
    { name: 'Girls', value: 1542, color: '#05CD99' },
];

export const totalValue = genderData.reduce((sum, data) => sum + data.value, 0);

export const stats = [
    { title: 'Total Students', value: '3242', icon: Users, color: '#FFD700' },
    { title: 'Total Teachers', value: '154', icon: GraduationCap, color: '#87CEEB' },
    { title: 'Total Employees', value: '338', icon: Building2, color: '#32CD32' },
    { title: 'Total Earnings', value: '₹00,000', icon: IndianRupee , color: '#FF6347' },
];
export const upcomingEvents = [
    { id: 1, title: 'Math Test', date: 'Tomorrow, 10:00 AM' },
    { id: 2, title: 'Science Project Due', date: 'Friday, 3:00 PM' },
    { id: 3, title: 'Parent-Teacher Meeting', date: 'Next Monday, 2:00 PM' },
    { id: 4, title: 'Eid ul Fitr', date: 'Next Wednesday, 5:00 AM' },
];

export const assignments = [
    { id: 1, subject: 'Mathematics', title: 'Quadratic Equations', dueDate: '2 days' },
    { id: 2, subject: 'History', title: 'World War II Essay', dueDate: '5 days' },
    { id: 3, subject: 'Physics', title: 'Motion Laws Report', dueDate: '1 week' },
];
export const gradeDistribution = [
    { name: 'A', value: 30 },
    { name: 'B', value: 40 },
    { name: 'C', value: 20 },
    { name: 'D', value: 8 },
    { name: 'F', value: 2 },
];

export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#FF0000'];